import { Article } from "@mui/icons-material";
import React from "react";
import FieldBlock from "./FieldBlock";

export function OrderNumberField(props) {
  const [value, setValue] = React.useState(
    props?.findParams?.orderNumber || ""
  );

  function changeValues(val) {
    props?.setFindParams((e) => {
      return {
        ...e,
        orderNumber: val ? val : null,
      };
    });
  }
  return (
    <React.Fragment>
      <FieldBlock
        icon={<Article />}
        label="order-number"
        length={36}
        onBlurFunc={changeValues}
        placeholder="Последние 5 цифр или весь номер документа"
        required={props?.required}
        setValue={setValue}
        title="Введите номер документа"
        value={value}
      />
    </React.Fragment>
  );
}
